<ideal-cart-item-price-view [itemId]="id()" [quantity]="quantity()" />
